<template>
  <v-app id="app" class="app">
    <v-app-bar app>
      <v-row>
        <v-col cols="2">
          <v-row v-if="$vuetify.breakpoint.smAndUp">
            <v-col v-for="item in menu" :key="item.text">
          <router-link :to="item.link" style="letter-spacing:2px">{{ item.text.toUpperCase() }}</router-link>
          </v-col>
          </v-row>
        </v-col>
        <v-col cols="8">
          <v-row>
            <v-col>
          <v-img alt="Fred Dope" class="shrink hidden-md-and-up ma-auto" contain src="@/assets/logo-circle.png"
          transition="scale-transition" width="45" />
        <v-img alt="Fred Dope" class="shrink ma-auto hidden-sm-and-down" contain min-width="100"
          src="@/assets/logo-white.png" width="150" />

            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2" v-if="$vuetify.breakpoint.smAndUp">
          <v-row>
            <v-col >
          <a href="https://instagram.com/freddopemusic" target="_blank">
            <font-awesome-icon :icon="['fab', 'instagram']" /></a>
        </v-col>
            <v-col>
          <a href="https://facebook.com/freddope" target="_blank">
            <font-awesome-icon :icon="['fab', 'facebook-f']" /></a>
        </v-col>
        <v-col>
          <a href="https://soundcloud.com/freddope" target="_blank">
            <font-awesome-icon :icon="['fab', 'soundcloud']" /></a>
        </v-col>
        <v-col >
          <a href="https://open.spotify.com/artist/19kHmmMlAlaB4agizfXRof" target="_blank">
            <font-awesome-icon :icon="['fab', 'spotify']" /></a>
        </v-col>
          </v-row>
        </v-col>
          <v-col cols="2" v-if="$vuetify.breakpoint.xs">
            <v-row>
              <v-col>
          <font-awesome-icon :icon="['fas', 'bars']" style="font-size:45px" @click="drawer = !drawer" />       
        </v-col>
        </v-row>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-navigation-drawer background-color="black" v-model="drawer" fixed temporary width="100%" class="align-center">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-img alt="Fred Dope" class="ml-0" contain min-width="100"
          src="@/assets/logo-white.png" width="150" />
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon>
          <font-awesome-icon @click="drawer = !drawer" pull="right" :icon="['fas', 'times']" />
        </v-list-item-icon>
      </v-list-item>

      <v-divider></v-divider>

      <v-list>

        <v-list-item class="text-center link-item" v-for="item in menu" :key="item.text">
          <v-list-item-content>
            <router-link :to="item.link">
              <v-list-item-title class="link">{{ item.text.toUpperCase() }}</v-list-item-title>
            </router-link>
          </v-list-item-content>
        </v-list-item>
      </v-list>
  
    </v-navigation-drawer>
    <v-container class="ma-0 pa-0" fluid>
      <v-row>
        <v-col>
          <v-content class="pl-0 pr-0">
            <router-view class="pa-0 ma-0" fluid/>
            
          </v-content>
        </v-col>
      </v-row>
    </v-container>
    <v-footer padless>
      <Footer/>
    </v-footer>

    <v-overlay :value="loading" opacity=1>
      <v-container>
        <v-row>
          <v-col class="text-center">
        <img alt="Fred Dope" style="max-width:200px" :src="require('@/assets/logo-white.png')">
          </v-col>
        </v-row>
        <v-row>
          <v-col class="text-center" transition="scale-transition">
            Hold on, I'm loading for you!
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>

  </v-app>
</template>

<script>
import Footer from '@/components/Footer.vue'
export default {
  name: 'App',

  components: {
    Footer
    },
  computed: {
    loading () {
      var status = this.$store.getters.getLoading
      if (!status.headlines && !status.ravecast && !status.releases && !status.post) {
      return false
    }
    else {
      return true
    }
    }
  },
  data: () => ({
    //
    drawer: false,
    menu: [
      {
        icon: 'home',
        text: 'Home',
        link: '/'
      },
      {
        icon: 'music',
        text: 'Music',
        link: '/music'
      },
      {
        icon: 'podcast',
        text: 'RaveCast',
        link: '/ravecast'
      } //,
      // {
      //  icon: 'paper-plane',
      //  text: 'Contacts',
      //  link: '/contacts'
      // }
    ]
  })
};
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Jost&family=Bebas+Neue&display=swap');
</style>
<style>
body {
  overflow: hidden;
  font-family: 'Jost', sans-serif;
}
.app {
  width: 100%;
  background-color: black;
  color: white;
}
.wrap {
  word-wrap: break-word;
}
.v-application {
   font-family: 'Jost', sans-serif!important;
 }
 .v-application a {
    color: white!important;
    text-decoration: none!important
}
.v-application a:hover {
    color: white!important;
    text-decoration: underline!important
}
.v-navigation-drawer__content {
  width: 100%
}
.link {
  font-size: 2em!important
}
.link-item {
  margin-top: 15%;
  margin-bottom: 15%;
}
h1 {
  font-family: 'Bebas Neue', sans-serif;
  font-size: 10vh;
  line-height:normal;
  text-transform: uppercase;
}
.h1-big {
  font-size: 3em!important
}
.v-slide-group__next, .v-slide-group__prev {
    min-width: 20px!important
}
.container {
  max-width: 100%!important
}
#app > div > div.container.ma-0.pa-0.container--fluid > div > div > main {
  padding: 40px 0px 0px!important;
}
.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background-color: black!important;;
}
.theme--dark.v-application {
  background-color: black!important;
}
#app > div > div.v-overlay.v-overlay--active.theme--dark > div.v-overlay__scrim {
  background-color: black!important;
}

.theme--dark.v-navigation-drawer {
  background-color: black!important;
}
</style>
